import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Card } from '../models/card.model';
import { map } from 'rxjs/operators';

const BASE_URL = environment.base_url;

@Injectable({
    providedIn: 'root'
})
export class CardService {

    constructor(
        private http: HttpClient
    ) { }


    list(): Observable<Card[]> {

        const url = `${BASE_URL}/cards`;
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`
        });

        return this.http.get(url, { headers }).pipe(
            map((resp: { cards: Card[] }) => resp.cards)
        )

    }

    create(tokenId): Observable<any> {

        const url = `${BASE_URL}/cards`;
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`
        });

        return this.http.post(url, { tokenId: tokenId }, { headers }).pipe(
            map((resp: { card: Card }) => resp.card)
        )
    }

}
